import React, { Component } from 'react'
import { AuthProvider } from '@/contexts/auth'
import { AuthResource } from '@/resources'
import { AuthStorage } from '@/storage/index'
import {
  withRouter
} from 'react-router-dom'
import { connect } from 'react-redux'
import { setUser } from '../../store/actions/user'

class AuthComponent extends Component {

  state = {
    authenticated: false,
    user:{
      role: 'visitor'
    },
    accessToken: '',
    error: null,
    userChecked: false
  }

  componentDidMount () {
    const hasAlreadyAuth = JSON.parse( AuthStorage.getValue() )
    if( hasAlreadyAuth ){
      const { location } = this.props.history
      this.setState( { ...hasAlreadyAuth, userChecked: true }, () => this.props.setUser( this.state ) )
      if( location.pathname === '/' ) {
        this.props.history.push( '/dashboard' )
      }
    }else {
      this.setState( {
        userChecked: true
      } )
    }
  }

  doToken = ( token ) => {
    AuthResource.checkToken( {
      token,
    } )
      .then( ( { data } ) => this.onLoginSuccess ( data ) )
      .catch( error => this.onLoginError( error ) )
  }

  doLogin = ( credentials ) =>{
    AuthResource.login( {
      email: credentials.username,
      password: credentials.password
    } )
      .then( ( { data } ) => this.onLoginSuccess( data ) )
      .catch( error => this.onLoginError( error ) )
  }

  logout = () => {
    this.setState( {
      authenticated: false,
      user: null,
      accessToken: null
    }, () => this.props.setUser( null ) )
    AuthStorage.deleteValue()
    this.props.history.push( '/' )
  }

  onLoginSuccess = ( { token, user } ) => {
    this.setState( {
      authenticated: true,
      user: user,
      accessToken: token
    }, () => this.props.setUser( this.state ) )
    AuthStorage.setValue( JSON.stringify( this.state ) )
    this.props.history.push( '/dashboard' )
  }

  onLoginError = ( err ) => {
    let message = null
    if( err.response && err.response.data ){
      message = err.response.data.message
    }
    this.setState( {
      authenticated: false,
      user: null,
      accessToken: null,
      error: message || 'Usuário ou senha inválidos'
    } )
  }

  render () {
    const authProviderValue = {
      ...this.state,
      doLogin: this.doLogin,
      doToken: this.doToken,
      logout: this.logout
    }
    return this.state.userChecked &&
    <AuthProvider value={authProviderValue}>
      {this.props.children}
    </AuthProvider>
  }
}

export default withRouter(
  connect( null, { setUser } )( AuthComponent )
)


// WEBPACK FOOTER //
// ./src/components/auth/AuthComponent.js